import React, {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Background} from "./components/Background";
import {Navigator} from "./components/Navigator";
import {Notice} from "./components/Notice";
import {Main} from "./pages/Main";
import {Statistics} from "./components/Statistics";
import {Profile} from "./pages/Profile";
import {Payment, Tariffs} from "./pages/Payment";
import {QRCode} from "./utils/QRCode";
import {Container} from "./components/Container";
import {Loading} from "./components/Loading";

import "./utils/stat";
import css from "./css/app.module.css";
import {Admin} from "./admin/Admin";
import {Stat} from "./utils/stat";
import {Page404} from "./pages/Page404";
import {MiniApp} from "./pages/MiniApp";
import {Problem} from "./components/Problem";
import {log} from "./utils/log";
import {TiktokBrowser} from "./pages/TiktokBrowser";

export const AppComponent = {
    Locked: () => {
    },
    Started: () => {
    },
    setRestriction: () => {
    },
    SetNotice: () => {
    },
    Forbidden: () => {
    },
    ShouldTrial: () => {
    },
    ShouldRenew: () => {
    },
    ShouldPay: () => {
    },
    SetLoading: () => {
    },
    adminForbidden: () => {
    },
};

const App = () => {
    useEffect(() => {
        log({event: "loaded"})
    }, [])

    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes("tiktok") || ua.includes("musical")) {
        return <TiktokBrowser/>
    }

    return (
        <Loading>
            <BrowserRouter>
                <div className={css.app}>
                    <Background/>
                    <Routes>
                        <Route path="/admin" element={<Admin/>}/>
                        <Route path="*" element={
                            <>
                                <Stat/>
                                <Routes>
                                    <Route path="/" element={<Main/>}/>
                                    <Route path="/qrcode" element={<QRCode/>}/>
                                    <Route path="/payment" element={<Tariffs/>}/>
                                    <Route path="/payment/:invoiceId" element={<Payment/>}/>
                                    <Route path="*" element={
                                        <MiniApp>
                                            <Notice/>
                                            <Container bottom={72}>
                                                <Routes>
                                                    <Route path="/app" element={<Problem/>}/>
                                                    <Route path="/statistics" element={<Statistics/>}/>
                                                    <Route path="/profile" element={<Profile/>}/>
                                                    <Route path="*" element={<Page404/>}/>
                                                </Routes>
                                            </Container>
                                            <Navigator height={72} paths={["/app", "/statistics", "/profile"]}/>
                                        </MiniApp>
                                    }/>
                                </Routes>
                            </>
                        }/>
                    </Routes>
                </div>
            </BrowserRouter>
        </Loading>
    )
};

export default App;
